import Vue from 'vue'
import VueRouter from 'vue-router'
import Problem from '../views/Problem.vue'
import Result from '../views/Result.vue'

import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Problem
  },
  {
    path: '/result/:id',
    name: 'Result',
    component: Result,
    props: true
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: async (to) => {
    if (to.hash) {
        const el = document.querySelector(to.hash)
        window.setTimeout(function(){
          if ('scrollBehavior' in document.documentElement.style) {
            return window.scrollTo({top: el.offsetTop, behavior: 'smooth'});
          } else {
            return window.scrollTo(0, el.offsetTop);
          }
        }, 1000);
    }
    return {x: 0, y: 0};
  },
})

export default router
